import { render, staticRenderFns } from "./OrdersStatistics.vue?vue&type=template&id=8bcd6c22&scoped=true&"
import script from "./OrdersStatistics.vue?vue&type=script&lang=js&"
export * from "./OrdersStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=8bcd6c22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcd6c22",
  null
  
)

export default component.exports